<template>
  <div class="campo-adicional-renderer">
    <label class="form-label">
      {{ campo.nome_exibicao }}
      <span v-if="campo.obrigatorio" class="text-danger">*</span>
    </label>

    <input
      v-if="campo.tipo_campo === 'text'"
      :value="modelValue || ''"
      type="text"
      class="form-control"
      :class="{ 'is-invalid': error }"
      :placeholder="campo.descricao_ajuda || 'Digite um valor'"
      @input="emitValue($event.target.value)"
    />

    <input
      v-else-if="campo.tipo_campo === 'number'"
      :value="modelValue ?? ''"
      type="number"
      class="form-control"
      :class="{ 'is-invalid': error }"
      :placeholder="campo.descricao_ajuda || 'Informe um número'"
      @input="emitValue($event.target.value === '' ? null : Number($event.target.value))"
    />

    <AppDatepicker
      v-else-if="campo.tipo_campo === 'date'"
      :model-value="modelValue || ''"
      mode="date"
      placeholder="dd/mm/aaaa"
      :input-class="{ 'is-invalid': error }"
      @update:model-value="emitValue"
    />

    <AppDatepicker
      v-else-if="campo.tipo_campo === 'time'"
      :model-value="modelValue || ''"
      mode="time"
      placeholder="hh:mm"
      :input-class="{ 'is-invalid': error }"
      @update:model-value="emitValue"
    />

    <div v-else-if="campo.tipo_campo === 'checkbox'" class="form-check form-switch pt-2">
      <input
        :checked="Boolean(modelValue)"
        class="form-check-input"
        type="checkbox"
        :class="{ 'is-invalid': error }"
        @change="emitValue($event.target.checked)"
      />
      <label class="form-check-label">Marcar opção</label>
    </div>

    <div v-else-if="campo.tipo_campo === 'radio'" class="d-flex flex-column gap-2 pt-1">
      <div v-for="opcao in opcoesAtivas" :key="opcao.valor" class="form-check">
        <input
          class="form-check-input"
          type="radio"
          :name="`campo-radio-${campo.id}`"
          :checked="modelValue === opcao.valor"
          @change="emitValue(opcao.valor)"
        />
        <label class="form-check-label">{{ opcao.label }}</label>
      </div>
    </div>

    <Multiselect
      v-else-if="campo.tipo_campo === 'dropdown' || campo.tipo_campo === 'multiselect_single'"
      :model-value="modelValue"
      :options="opcoesMultiselect"
      label="label"
      value-prop="value"
      :searchable="true"
      :can-clear="!campo.obrigatorio"
      :can-deselect="!campo.obrigatorio"
      :class="{ 'is-invalid': error }"
      :placeholder="campo.descricao_ajuda || 'Selecione'"
      @update:model-value="emitValue"
    />

    <Multiselect
      v-else-if="campo.tipo_campo === 'multiselect_tags'"
      :model-value="Array.isArray(modelValue) ? modelValue : []"
      mode="tags"
      :close-on-select="false"
      :searchable="true"
      :create-option="false"
      :options="opcoesMultiselect"
      label="label"
      value-prop="value"
      :class="{ 'is-invalid': error }"
      :placeholder="campo.descricao_ajuda || 'Selecione uma ou mais opções'"
      @update:model-value="emitValue"
    />

    <input
      v-else-if="campo.tipo_campo === 'color'"
      :value="modelValue || '#1f6feb'"
      type="color"
      class="form-control form-control-color"
      :class="{ 'is-invalid': error }"
      @input="emitValue($event.target.value)"
    />

    <input
      v-else
      :value="modelValue || ''"
      type="text"
      class="form-control"
      :class="{ 'is-invalid': error }"
      @input="emitValue($event.target.value)"
    />

    <small v-if="campo.descricao_ajuda" class="text-muted d-block mt-1">{{ campo.descricao_ajuda }}</small>
    <div v-if="error" class="invalid-feedback d-block">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: 'CampoAdicionalRenderer',
  props: {
    campo: { type: Object, required: true },
    modelValue: { type: [String, Number, Boolean, Array, Object, null], default: null },
    error: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  computed: {
    opcoesAtivas() {
      return Array.isArray(this.campo.opcoes)
        ? this.campo.opcoes.filter((opcao) => opcao.ativo !== false)
        : [];
    },
    opcoesMultiselect() {
      return this.opcoesAtivas.map((opcao) => ({ value: opcao.valor, label: opcao.label }));
    },
  },
  methods: {
    emitValue(value) {
      this.$emit('update:modelValue', value);
    },
  },
};
</script>